const fromMillimitersToMeters = (mm: number): number => {
  return mm / 1000;
};

export default fromMillimitersToMeters;
